module.exports = __webpack_public_path__ + "assets/dd8d4ab4f0834e51c914d9a5e112fbe7.mp4";